import React from "react";
import "../style/nav.css";
import { Container, Nav, Navbar, Button } from "react-bootstrap";

const navbar = () => {
    return (
        <Navbar expand="lg">
          <Container>
            <Navbar.Brand href="/"><img
                src="/images/logo.svg"
                alt="wengmack"
                className="img-fluid nav-logo"
              /> Wengmack</Navbar.Brand>
            <Navbar.Toggle aria-controls="basic-navbar-nav" />
            <Navbar.Collapse id="basic-navbar-nav">
              <Nav className="ms-auto">
                <Nav.Link href="/about-us">About Us</Nav.Link>
                <Nav.Link href="/login" className="ms-3"><i className="bi bi-box-arrow-in-right"></i> Login</Nav.Link>
                <Nav.Link href="/signUp" variant="primary" className="ms-3">Sign Up <i className="bi bi-person-plus"></i></Nav.Link>
              </Nav>
            </Navbar.Collapse>
          </Container>
        </Navbar>
    );
};

export default navbar;
